// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { LinkWithIcon, LinkWithIconProps } from "./link-with-icon";
import { ListOfLinksHeaderText } from "./list-of-links-header-text";

export type ListOfLinksProps = {
    readonly isSideBar: boolean;
    readonly headerText: string;
    readonly listOfLinkWithProps: LinkWithIconProps[];
};

export const ListOfLinks = ({
    isSideBar,
    headerText,
    listOfLinkWithProps
}: ListOfLinksProps) => {
    const linkListContainerStyle = [
        isSideBar &&
            css({
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                float: "left",
                padding: `0 0 ${token("space.250")} 0`,
                marginBlockEnd: "10px"
            }),
        !isSideBar &&
            css({
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                float: "left",
                padding: `0 ${token("space.250")} 0 0`,
                marginBlockEnd: "10px"
            })
    ];
    return (
        <div css={linkListContainerStyle}>
            <ListOfLinksHeaderText
                isSideBar={isSideBar}
                headerText={headerText}
            />
            {listOfLinkWithProps.map((listOfLinkWithProp, index) => {
                const listOfLinkKey =
                    headerText.trim().toLowerCase() +
                    "-" +
                    listOfLinkWithProp.linkText.trim().toLowerCase() +
                    "-" +
                    index.toString();
                return (
                    <React.Fragment key={listOfLinkKey}>
                        <LinkWithIcon {...listOfLinkWithProp} />
                    </React.Fragment>
                );
            })}
        </div>
    );
};
